import { render, staticRenderFns } from "./PortalMobile.vue?vue&type=template&id=7331da30&"
import script from "./PortalMobile.vue?vue&type=script&lang=js&"
export * from "./PortalMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7331da30')) {
      api.createRecord('7331da30', component.options)
    } else {
      api.reload('7331da30', component.options)
    }
    module.hot.accept("./PortalMobile.vue?vue&type=template&id=7331da30&", function () {
      api.rerender('7331da30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/common/PortalMobile.vue"
export default component.exports